import React, { useCallback, useState } from "react";

import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import UploadFileIcon from "@mui/icons-material/UploadFile";

import { ButtonUI } from "../../../../../Common";

import { setPrevState } from "../../../../../../util/common";
import { regexFilePath } from "../../../../../../util/regularExpress";
import { browserStateVar } from "../../../utils/JobData";
import S3FileBrowser from "../../../../Browsers/S3FileBrowser";
import AzureFileBrowser from "../../../../Browsers/AzureFileBrowser";
import SSHFileBrowser from "../../../../Browsers/SSHFileBrowser";

const BrowseInput = ({ exchangeJobState, setExchangeJobState, jobPurpose, $destinationList }) => {
  const { destination, sourceType, targetPath } = exchangeJobState;

  const [openBrowser, setOpenBrowser] = useState({
    sftpBrowser: false,
    azureBrowser: false,
    s3Browser: false,
  });

  const handleBrowser = useCallback((browser, val) => {
    const prop = browserStateVar[browser];
    setOpenBrowser((prev) => {
      const newState = {};
      Object.keys(prev).forEach((key) => {
        newState[key] = key === prop ? val : false;
      });

      return newState;
    });
  }, []);

  const handleBrowseClick = useCallback(() => {
    // find selected source and set bucket and open according browser
    const locationDetail = $destinationList.find((locationDetail) => locationDetail.Stage_id === destination);

    if (locationDetail) {
      const Detail = locationDetail.Detail;
      setPrevState(setExchangeJobState, {
        bucket: Detail.url,
      });
      handleBrowser(Detail.type.toLowerCase(), true);
    }
  }, [$destinationList, destination, handleBrowser, setExchangeJobState]);

  const handleS3Browser = useCallback((val) => handleBrowser("s3", val), [handleBrowser]);
  const handleAzureBrowser = useCallback((val) => handleBrowser("azure", val), [handleBrowser]);
  const handleSFTPBrowser = useCallback((val) => handleBrowser("sftp", val), [handleBrowser]);

  const setPath = (pathValue) => {
    setPrevState(setExchangeJobState, { targetPath: pathValue });
  };

  return (
    <>
      <FormControl
        sx={{
          width: { xs: "100%", sm: "300px" },
          m: 1,
          ml: 0,
        }}
      >
        <TextField
          value={targetPath}
          required
          label="Folder path"
          inputProps={{ maxLength: 255 }}
          onChange={(e) => {
            if (e.target.value === "") setPrevState(setExchangeJobState, { targetPath: "" });
            else if (regexFilePath(e.target.value)) setPrevState(setExchangeJobState, { targetPath: e.target.value });
          }}
          onBlur={() => {
            if (targetPath && targetPath[0] !== "/")
              setPrevState(setExchangeJobState, { targetPath: "/" + targetPath });
            if (targetPath && !targetPath.endsWith("/"))
              setPrevState(setExchangeJobState, { targetPath: targetPath + "/" });
          }}
          helperText={`Not allowed characters \\:;~*'?"<>|`}
        />
      </FormControl>
      <ButtonUI
        disabled={!(destination && sourceType)}
        color="secondary"
        component="span"
        variant="contained"
        endIcon={<UploadFileIcon />}
        sx={{
          marginTop: "18px",
        }}
        onClick={handleBrowseClick}
      >
        Browse
      </ButtonUI>

      {openBrowser.s3Browser && (
        <S3FileBrowser
          setOpenFileBrowser={handleS3Browser}
          url={exchangeJobState.bucket}
          path={exchangeJobState.targetPath}
          setPath={setPath}
          stage={exchangeJobState.destination}
          locationName={
            exchangeJobState.destination &&
            exchangeJobState.locationList?.find((loc) => loc.Stage_id === exchangeJobState.destination).Name
          }
          folderSelection
        />
      )}
      {openBrowser.azureBrowser && (
        <AzureFileBrowser
          container={exchangeJobState.desinationContainer}
          setOpenFileBrowser={handleAzureBrowser}
          stage={exchangeJobState.destination}
          locationName={
            exchangeJobState.destination &&
            exchangeJobState.locationList?.find((loc) => loc.Stage_id === exchangeJobState.destination).Name
          }
          path={`${
            exchangeJobState.targetPath
              ? "/" +
                exchangeJobState.targetPath
                  .split(",/")
                  .map((p, i) => `${exchangeJobState.desinationContainer}${i === 0 ? "" : "/"}${p}`)
                  .join(",/")
              : `/${exchangeJobState.desinationContainer}/`
          }`}
          setPath={(pathValue) => {
            setPrevState(setExchangeJobState, {
              targetPath: pathValue
                .replace(new RegExp(`^/${exchangeJobState.desinationContainer}`), "")
                .replace(new RegExp(`,/${exchangeJobState.desinationContainer}`, "g"), ","),
            });
          }}
          folderSelection
        />
      )}
      {openBrowser.sftpBrowser && (
        <SSHFileBrowser
          setOpenFileBrowser={handleSFTPBrowser}
          stage={exchangeJobState.destination}
          locationName={
            exchangeJobState.destination &&
            exchangeJobState.locationList?.find((loc) => loc.Stage_id === exchangeJobState.destination).Name
          }
          url={exchangeJobState.bucket || "/"}
          pathStr={exchangeJobState.targetPath}
          setPath={setPath}
          folderSelection
        />
      )}
    </>
  );
};

export default BrowseInput;
